import {AccountInfo} from '@azure/msal-browser';
import {getData} from './base';


export async function getFilterData (filter: string, accounts: AccountInfo[],
    showAll?: boolean) {
    const data = await getData(filter, accounts);
    if (showAll) {
        data.value.unshift({id: 0, value: 'All'});
    }
     if (filter.toLowerCase() === "coverage") {
        if (showAll) {
            // Keep "All" at the top, sort the rest
            const [first, ...rest] = data.value;
            data.value = [
                first,
                ...rest.sort((a: { value: string; }, b: { value: string; }) =>
                     a.value.localeCompare(b.value)),
            ];
        } else {
            // Sort everything
            data.value.sort((a: { value: string; }, b: { value: string; }) =>
                 a.value.localeCompare(b.value));
        }
    }
    return data.value;
}

function formatCarrierResponse(res: any[]) {
    const data: any[] = [];

    res.forEach((eachData) => {
        const index = data.findIndex((row) =>
            eachData.CompanyId === row.CompanyId &&
            eachData.CoverageId === row.CoverageId
        );

        if (index >= 0) {
            // Add FacilityTypeId if not already present
            if (!data[index].FacilityTypeId.includes(eachData.FacilityTypeId)) {
                data[index].FacilityTypeId.push(eachData.FacilityTypeId);
            }

            // Add ContactId if not already present
            if (!data[index].ContactId.includes(eachData.ContactId)) {
                data[index].ContactId.push(eachData.ContactId);
            }
        } else {
            data.push({
                ...eachData,
                FacilityTypeId: [eachData.FacilityTypeId],
                ContactId: [eachData.ContactId]
            });
        }
    });

    return data;
}


export async function getCarrierData (filter: string, accounts: AccountInfo[]) {
    const data = await getData(filter, accounts);
    return formatCarrierResponse(data.value);
}

export async function getCompanyDetailId (filter: string,
    accounts: AccountInfo[]) {
    const res = await getData(filter, accounts);
    if (res.value[0].CompanyDetailId) {
        return res.value[0].CompanyDetailId;
    } else {
        return 0;
    }
}

export async function getDataApi (filter: string, accounts: AccountInfo[]) {
    const res = await getData(filter, accounts);
    return res.value;
}

export async function getLogsApi(endpoint: string, accounts: AccountInfo[]) {
    try {
        const res = await getData(endpoint, accounts);
        return {res, value: res.value, status: res.status};
    } catch (error) {
        return {error};
    }
}


export async function getUserTotalApi(accounts: AccountInfo[]) {
    try {
        const res = await getData(`GetUserTotal`, accounts);
        return {res, value: res.value, status: res.status};
    } catch (error) {
        return {error};
    }
}

export async function getUserByRoleIdApi(
    userRoleId: string, accounts: AccountInfo[]) {
    try {
        const res = await getData(`GetUser?UserRoleId=${userRoleId}`, accounts);
        return {res, value: res.value, status: res.status};
    } catch (error) {
        return {error};
    }
}